export default __webpack_public_path__ + "static/media/gallery_01.772b8e88.jpg";